<div>
  <app-privacy-policy></app-privacy-policy>
</div>
